import type {Price} from '@/redux/v1/models';
import type {Theme} from '@travel-frontend/themes';

import styled from '@emotion/styled';
import {NoWrap} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

type Props = React.PropsWithChildren<{
  priceMin?: Price;
}>;

const Container = styled(NoWrap)`
  color: ${({theme}: {theme: Theme}) => theme.colors.contentSecondary};
  ${({theme}: {theme: Theme}) => theme.typography.labelXSmall}
`;

export const BestPrice: React.FunctionComponent<Props> = ({priceMin}) => {
  const {t} = useTranslation('general');

  if (priceMin === undefined) {
    return null;
  }

  return (
    <Container>
      {t('general:bestPrice', {
        price: priceMin.amount,
        currency: priceMin.currency,
      })}
    </Container>
  );
};
